import setup from "../config";
import { clearAllTokens } from "./cache";

const MENSAGEM_TOKEN_INVALIDO = "Token Inválido";

async function handleErrors(res) {
  const { ok, status } = res;
  if (!ok) {
    if (status === 401) {
      const persist_api_url = localStorage.getItem("API_URL");
      const persist_cdn_url = localStorage.getItem("CDN_URL");
      const persist_ws_host = localStorage.getItem("WS_HOST");
      const persist_ws_key = localStorage.getItem("WS_KEY");
      const persist_ws_port = localStorage.getItem("WS_PORT");

      localStorage.clear();

      if (persist_api_url) {
        localStorage.setItem("API_URL", persist_api_url);
      }

      if (persist_cdn_url) {
        localStorage.setItem("CDN_URL", persist_cdn_url);
      }

      if (persist_ws_host) {
        localStorage.setItem("WS_HOST", persist_ws_host);
      }

      if (persist_ws_key) {
        localStorage.setItem("WS_KEY", persist_ws_key);
      }

      if (persist_ws_port) {
        localStorage.setItem("WS_PORT", persist_ws_port);
      }

      clearAllTokens();

      location.href = "/login";
      throw Error(MENSAGEM_TOKEN_INVALIDO);
    }
    let json = await res.json();
    const erro = Error(
      (json.errors ? json.errors[0].detail : null) ||
        json.error ||
        json.message ||
        res.statusText
    );

    // O corpo inteiro segue junto para quem precisar de mais que a mensagem —
    // a crítica do ERP, por exemplo, vem num campo à parte. A chave é
    // namespaced de propósito: `errors`/`error`/`data` já têm significado em
    // alguns consumidores, e sobrescrevê-las mudaria o texto que eles exibem.
    erro.apiResponse = json;
    erro.apiStatus = status;

    throw erro;
  }
  return res;
}

function request(method, url, body, opts = {}) {
  const config = {
    method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  if (opts.isFile) {
    config.body = body;
  } else {
    config.headers["Content-Type"] = "application/json";
    config.body = JSON.stringify(body);
  }

  // Quem chama pode desistir da espera. Nenhuma chamada existente passa o
  // sinal, então quem não passar continua sem prazo, como antes.
  if (opts.signal) {
    config.signal = opts.signal;
  }

  return fetch(url, config)
    .then(handleErrors)
    .then((res) => res.json());
}

function upload(url, inputName, inputFile, extraInputs) {
  let formData = new FormData();
  formData.append(inputName, inputFile, inputName);

  if (extraInputs) {
    Object.keys(extraInputs).forEach((key) => {
      formData.append(key, extraInputs[key]);
    });
  }

  let token = localStorage.getItem("token");

  const params = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  };

  return fetch(url, params).then(async (res) => {
    if (res.ok) {
      return res.json();
    }
    throw await res.json();
  });
}

const get = (url) => request("GET", `${setup.api}${url}`);
const post = (url, body, opts = {}) =>
  request("POST", `${setup.api}${url}`, body, opts);
const put = (url, body) => request("PUT", `${setup.api}${url}`, body);
const patch = (url, body) => request("PATCH", `${setup.api}${url}`, body);
const del = (url, body) => request("DELETE", `${setup.api}${url}`, body);

function getToken(body) {
  const config = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };

  return fetch(`${setup.api}/login/adm`, config)
    .then(handleErrors)
    .then((res) => res.json());
}

function requestTokenResetPassword(body) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  };

  return fetch(`${setup.api}/senha/requisitar-token-redefinicao`, config)
    .then(handleErrors)
    .then((res) => res.json());
}

function validateResetToken(body) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  };

  return fetch(`${setup.api}/senha/validar-token`, config)
    .then(handleErrors)
    .then((res) => res.json());
}

function resetPasswordByToken(body) {
  const config = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  };

  return fetch(`${setup.api}/senha/redefinir-via-token`, config)
    .then(handleErrors)
    .then((res) => res.json());
}

function uploadImage({ el, str, dim }) {
  let { 0: w, 1: h } = dim.split("x");
  let formData = new FormData();
  formData.append("w", w);
  formData.append("h", h);
  formData.append("img", el.files[0], el.files[0].name);
  return post(`/admin/upload${str}`, formData, { isFile: true });
}

function uploadImageCdn(url, inputFile, fileName) {
  let formData = new FormData();
  formData.append("image", inputFile, fileName);

  return fetch(url, {
    method: "post",
    body: formData,
  }).then(handleErrors);
}

function open({ url, newTab = true }) {
  const urlOpen = `${setup.api}${url}`;
  const targetTab = newTab ? "_blank" : "_self";

  fetch(urlOpen, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((response) => response.blob())
    .then((blob) => {
      var _url = window.URL.createObjectURL(blob);
      window.open(_url, targetTab).focus();
    })
    .catch((err) => {
      console.log(err);
    });
}

const getBlob = async (url) => {
  const response = await fetch(`${setup.api}${url}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (!response.ok) {
    try {
      // Mesmo tratamento dos outros verbos: 401 limpa a sessão e redireciona
      // para o login; demais erros viram Error com a mensagem da API.
      await handleErrors(response);
    } catch (error) {
      // Corpo não-JSON (HTML de proxy/504): não mascarar com SyntaxError.
      throw error instanceof SyntaxError
        ? new Error(response.statusText || "Erro ao fazer download do arquivo")
        : error;
    }
  }

  return response;
};

const postBlob = async (url, body = {}, opts = {}) => {
  const config = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  if (opts.isFile) {
    config.body = body;
  } else {
    config.headers["Content-Type"] = "application/json";
    config.body = JSON.stringify(body);
  }

  const response = await fetch(`${setup.api}${url}`, config);

  if (!response.ok) {
    const json = await response.json();
    throw new Error(
      json.error || json.message || "Erro ao fazer download do arquivo"
    );
  }

  return response;
};

// No 401 o handleErrors ja redireciona para o login; quem trata o erro pode
// ignorar esse caso em vez de mostrar aviso enquanto a pagina sai.
const isSessaoExpirada = (erro) =>
  !!erro && erro.message === MENSAGEM_TOKEN_INVALIDO;

export {
  isSessaoExpirada,
  request,
  get,
  post,
  postBlob,
  getBlob,
  open,
  put,
  patch,
  del,
  upload,
  getToken,
  requestTokenResetPassword,
  validateResetToken,
  resetPasswordByToken,
  uploadImage,
  uploadImageCdn,
};
